export const convertListNotification = (data) => {
  let converted = [];

  if (!data) return [];

  data.forEach((item, index) => {
    converted.push({
      key: index + 1,
      id: item.id,
      name: item.name,
      days: item.details?.map((e, index) =>
        index + 1 === item.details?.length ? `${e.value}` : `${e.value}, `
      ),
    });
  });
  return converted;
};
